
const env_name =(typeof process.env.REACT_APP_DATALOADER_APP_ENV  !== "undefined" )  ? process.env.REACT_APP_DATALOADER_APP_ENV : 'local'

const coststandards = {
  appName: 'DLA',
  loaderType: 'coststandards',

  oAuth: {
    preprod: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token',
    client_id: "nike.pcx.dlacoststandardsimport",
    redirect_uri: window.location.origin + `/${env_name}`,
    response_type: 'authorization_code',
    basePath: window.location.origin,
    scope: 'profile openid email',
    pathName: `/${env_name}`
    },
    prod:{
    authorization: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize',
    token: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/token',
    client_id: "nike.pcx.dlacoststandardsimport",
        redirect_uri: window.location.origin,
    response_type: 'authorization_code',
    basePath: window.location.origin,
    scope: 'profile openid email',
    pathName: `/${env_name}`

    }
  }
};



export default coststandards


